import React, { forwardRef } from 'react';
import './CustomSelect.css';

export interface CustomSelectOption {
    label: string;
    value: string | number;
}

export interface CustomSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    label?: string;
    options: CustomSelectOption[];
    error?: string;
    leftIcon?: React.ReactNode;
    helperText?: string;
    placeholder?: string;
}

const CustomSelect = forwardRef<HTMLSelectElement, CustomSelectProps>(
    ({ label, options, error, leftIcon, helperText, className = '', ...props }, ref) => {
        return (
            <div className={`custom-select-container ${className}`}>
                {label && (
                    <label className="custom-select-label">
                        {label} {props.required && <span style={{ color: '#ef4444' }}>*</span>}
                    </label>
                )}
                
                <div className={`custom-select-wrapper ${error ? 'error' : ''}`}>
                    {leftIcon && <div className="custom-select-icon">{leftIcon}</div>}
                    
                    <select 
                        ref={ref} 
                        className={`custom-select-field ${leftIcon ? 'has-icon' : ''}`}
                        {...props}
                    >
                        <option value="" disabled>{props.placeholder || 'Select an option'}</option>
                        {options.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </div>
                
                {error && <p className="custom-select-error-text">{error}</p>}
                {helperText && !error && <p className="custom-select-helper-text">{helperText}</p>}
            </div>
        );
    }
);

CustomSelect.displayName = 'CustomSelect';

export default CustomSelect;
